// ensurePineScriptAdapter — on-demand Pro adapter load for the Pine editor panel.
//
// WHY THIS EXISTS (WS2 / PLAN_P3_3_CLOSE_GAPS_2026-10-28, audit O1). The Pro adapter is
// registered ONLY as a side effect of `@vninvestcharts/widget-pro/register` (`register.ts:40`).
// The package index does NOT import register (deliberate open-core split), and
// `usePineScriptRestore` bails out early when the layout has no `pine_*` series — so opening
// the Pine tab on a clean layout left `getPineScriptAdapter()` null forever and the old
// `setTimeout(..., 200)` poll in `PineEditorPanel` could never succeed. This helper lets the
// (Pro-gated) panel load the register entry point itself when it mounts.
//
// Fail-closed (Rule 15): a chunk that fails to load, or loads without registering, resolves
// to null — the panel keeps its loading state instead of crashing.
import { getPineScriptAdapter } from "../../lib/pinescript/adapter";
let inflight = null;
export function ensurePineScriptAdapter(load = () => import("@vninvestcharts/widget-pro/register")) {
    const ready = getPineScriptAdapter();
    if (ready)
        return Promise.resolve(ready);
    if (inflight)
        return inflight;
    inflight = load()
        .then(() => getPineScriptAdapter())
        .catch(() => null)
        .finally(() => {
        inflight = null;
    });
    return inflight;
}
export function __resetEnsureAdapterForTests() {
    inflight = null;
}
